// import { useEffect, useState } from "react";

// const PageLoader = () => {
//   const [loading, setLoading] = useState(true);

//   useEffect(() => {
//     const timeout = setTimeout(() => {
//       setLoading(false);
//     }, 4000); // Show loader for 2.5 sec
//     return () => clearTimeout(timeout);
//   }, []);

//   if (!loading) return null;

//   return (
//     <div className="fixed inset-0 z-[9999] bg-[#0f172a] text-white flex flex-col justify-center items-center transition-opacity duration-700">
//       {/* Double Line Spinner */}
//       <div className="relative w-24 h-24">
//         {/* Outer Ring */}
//         <div className="absolute inset-0 rounded-full border-[16px] border-double border-emerald-500 opacity-20"></div>
//         <div className="absolute inset-0 rounded-full border-t-[16px] border-double border-b-[16px] border-emerald-500 animate-spin"></div>

//         {/* Inner Ring */}
//         <div className="absolute inset-2 rounded-full border-4 border-emerald-400 opacity-10"></div>
//         <div className="absolute inset-2 rounded-full border-r-4 border-l-4 border-emerald-400 animate-spin-slow"></div>
//       </div>

//       {/* Text */}
//       <h1 className="mt-5 text-lg font-semibold tracking-wide text-gray-200 animate-pulse">
//         Launching <span className="text-emerald-500">MominHussain</span>...
//       </h1>
//     </div>
//   );
// };

// export default PageLoader;

// import { useEffect, useState } from "react";

// const PageLoader = () => {
//   const [loading, setLoading] = useState(true);
//   const [currentLoader, setCurrentLoader] = useState(0);

//   useEffect(() => {
//     const interval = setInterval(() => {
//       setCurrentLoader((prev) => (prev + 1) % 3);
//     }, 1300);

//     const timeout = setTimeout(() => {
//       setLoading(false);
//       clearInterval(interval);
//     }, 4000);

//     return () => {
//       clearTimeout(timeout);
//       clearInterval(interval);
//     };
//   }, []);

//   if (!loading) return null;

//   const loaders = [
//     // Loader 1: 3D Cube Spinner
//     <div className="relative w-32 h-32">
//       <div className="absolute inset-0 transform-style-3d animate-spin-3d">
//         {/* Front face */}
//         <div className="absolute w-20 h-20 bg-gradient-to-br from-blue-500 to-purple-600 transform-translate-z-10 rounded-lg shadow-2xl shadow-blue-500/50"></div>

//         {/* Back face */}
//         <div className="absolute w-20 h-20 bg-gradient-to-br from-purple-600 to-pink-600 transform-rotate-y-180 translate-z-10 rounded-lg shadow-2xl shadow-purple-500/50"></div>

//         {/* Top face */}
//         <div className="absolute w-20 h-20 bg-gradient-to-br from-cyan-500 to-blue-600 transform-rotate-x-90 translate-z-10 rounded-lg shadow-2xl shadow-cyan-500/50"></div>

//         {/* Bottom face */}
//         <div className="absolute w-20 h-20 bg-gradient-to-br from-pink-600 to-rose-600 transform-rotate-x--90 translate-z-10 rounded-lg shadow-2xl shadow-pink-500/50"></div>

//         {/* Left face */}
//         <div className="absolute w-20 h-20 bg-gradient-to-br from-indigo-600 to-blue-600 transform-rotate-y--90 translate-z-10 rounded-lg shadow-2xl shadow-indigo-500/50"></div>

//         {/* Right face */}
//         <div className="absolute w-20 h-20 bg-gradient-to-br from-violet-600 to-purple-600 transform-rotate-y-90 translate-z-10 rounded-lg shadow-2xl shadow-violet-500/50"></div>
//       </div>

//       {/* Glow effect */}
//       <div className="absolute inset-0 rounded-full bg-blue-500/10 blur-xl animate-pulse"></div>
//     </div>,

//     // Loader 2: 3D Orbital System
//     <div className="relative w-32 h-32">
//       {/* Central Sphere */}
//       <div className="absolute inset-0 flex items-center justify-center">
//         <div className="w-12 h-12 bg-gradient-to-r from-emerald-500 to-teal-400 rounded-full shadow-2xl shadow-emerald-500/50 animate-pulse"></div>
//         <div className="absolute w-16 h-16 border-2 border-emerald-400/30 rounded-full animate-ping"></div>
//       </div>

//       {/* Orbiting Rings */}
//       <div className="absolute inset-0 animate-spin-3d-slow">
//         <div className="absolute top-0 left-1/2 -translate-x-1/2 w-4 h-4 bg-gradient-to-r from-cyan-500 to-blue-500 rounded-full shadow-lg shadow-cyan-500"></div>
//         <div className="absolute bottom-0 left-1/2 -translate-x-1/2 w-4 h-4 bg-gradient-to-r from-purple-500 to-pink-500 rounded-full shadow-lg shadow-purple-500"></div>
//         <div className="absolute left-0 top-1/2 -translate-y-1/2 w-4 h-4 bg-gradient-to-r from-orange-500 to-red-500 rounded-full shadow-lg shadow-orange-500"></div>
//         <div className="absolute right-0 top-1/2 -translate-y-1/2 w-4 h-4 bg-gradient-to-r from-yellow-500 to-amber-500 rounded-full shadow-lg shadow-yellow-500"></div>
//       </div>

//       {/* Outer Orbit Ring */}
//       <div className="absolute inset-0 border-2 border-dashed border-white/20 rounded-full animate-spin-reverse"></div>
//     </div>,

//     // Loader 3: 3D Hexagon Processor
//     <div className="relative w-32 h-32">
//       {/* Hexagon Grid */}
//       <div className="absolute inset-0 flex items-center justify-center">
//         <div className="relative w-24 h-24">
//           {/* Outer Hexagon */}
//           <div className="absolute inset-0 bg-gradient-to-r from-blue-600/20 to-purple-600/20 clip-path-hexagon animate-pulse"></div>

//           {/* Rotating Hexagon */}
//           <div className="absolute inset-2 bg-gradient-to-r from-cyan-500/30 to-blue-500/30 clip-path-hexagon animate-spin-3d"></div>

//           {/* Inner Hexagon */}
//           <div className="absolute inset-4 bg-gradient-to-r from-emerald-500/40 to-teal-400/40 clip-path-hexagon animate-pulse-slow"></div>

//           {/* Core */}
//           <div className="absolute inset-8 bg-gradient-to-r from-white to-emerald-200 clip-path-hexagon shadow-2xl shadow-emerald-500/50"></div>
//         </div>
//       </div>

//       {/* Floating Particles */}
//       {[...Array(6)].map((_, i) => (
//         <div
//           key={i}
//           className="absolute w-2 h-2 bg-gradient-to-r from-cyan-400 to-blue-400 rounded-full animate-float"
//           style={{
//             left: `${50 + 40 * Math.cos((i * 60 * Math.PI) / 180)}%`,
//             top: `${50 + 40 * Math.sin((i * 60 * Math.PI) / 180)}%`,
//             animationDelay: `${i * 0.2}s`
//           }}
//         ></div>
//       ))}
//     </div>
//   ];

//   return (
//     <div className="fixed inset-0 z-[9999] bg-gradient-to-br from-gray-900 via-slate-900 to-gray-950 text-white flex flex-col justify-center items-center transition-opacity duration-700 overflow-hidden">
//       {/* Animated Background Elements */}
//       <div className="absolute inset-0 overflow-hidden">
//         <div className="absolute top-1/4 left-1/4 w-64 h-64 bg-blue-500/5 rounded-full blur-3xl animate-pulse"></div>
//         <div className="absolute bottom-1/4 right-1/4 w-64 h-64 bg-purple-500/5 rounded-full blur-3xl animate-pulse delay-700"></div>
//         <div className="absolute top-3/4 left-3/4 w-48 h-48 bg-emerald-500/5 rounded-full blur-3xl animate-pulse delay-1000"></div>
//       </div>

//       {/* Current Loader */}
//       <div className="relative z-10">
//         {loaders[currentLoader]}
//       </div>

//       {/* Text with Tech Stack Animation */}
//       <div className="mt-8 text-center">
//         <h1 className="text-2xl font-bold bg-gradient-to-r from-cyan-400 via-blue-400 to-purple-400 bg-clip-text text-transparent animate-gradient">
//           Crafting Digital Excellence
//         </h1>
//         <p className="mt-2 text-gray-300 text-sm max-w-md">
//           Initializing{" "}
//           <span className="inline-flex items-center">
//             {["React", "Next.js", "Tailwind", "Node.js"].map((tech, idx) => (
//               <span
//                 key={tech}
//                 className="mx-1 px-2 py-1 bg-white/5 rounded text-emerald-400 font-medium animate-tech-fade"
//                 style={{ animationDelay: `${idx * 0.5}s` }}
//               >
//                 {tech}
//               </span>
//             ))}
//           </span>
//         </p>
//         <div className="mt-4 flex justify-center space-x-2">
//           <div className="w-2 h-2 bg-cyan-500 rounded-full animate-bounce"></div>
//           <div className="w-2 h-2 bg-blue-500 rounded-full animate-bounce" style={{ animationDelay: "0.2s" }}></div>
//           <div className="w-2 h-2 bg-purple-500 rounded-full animate-bounce" style={{ animationDelay: "0.4s" }}></div>
//         </div>
//       </div>

//       {/* Loading Progress */}
//       <div className="absolute bottom-10 w-64">
//         <div className="h-1 bg-gray-800 rounded-full overflow-hidden">
//           <div className="h-full bg-gradient-to-r from-cyan-500 via-blue-500 to-purple-500 animate-progress"></div>
//         </div>
//         <div className="mt-2 flex justify-between text-xs text-gray-400">
//           <span>Loading</span>
//           <span className="text-emerald-400 font-medium">Web Development Services</span>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default PageLoader;


import { useEffect, useState } from "react";

const PageLoader = () => {
  const [loading, setLoading] = useState(true);
  const [currentLoader, setCurrentLoader] = useState(0);
  const [percentage, setPercentage] = useState(0);

  useEffect(() => {
    // Progress bar animation
    const progressInterval = setInterval(() => {
      setPercentage(prev => {
        if (prev >= 100) {
          clearInterval(progressInterval);
          return 100;
        }
        return prev + Math.random() * 15;
      });
    }, 200);

    // Loader rotation animation
    const interval = setInterval(() => {
      setCurrentLoader((prev) => (prev + 1) % 3);
    }, 1300);

    const timeout = setTimeout(() => {
      setLoading(false);
      clearInterval(interval);
      clearInterval(progressInterval);
    }, 4000);

    return () => {
      clearTimeout(timeout);
      clearInterval(interval);
      clearInterval(progressInterval);
    };
  }, []);

  if (!loading) return null;

  const loaders = [
    // Loader 1: 3D Cube Spinner (Improved with proper CSS classes)
    <div className="relative w-32 h-32">
      <div className="absolute inset-0 [transform-style:preserve-3d] animate-[spin_8s_linear_infinite]">
        {/* Front face */}
        <div className="absolute w-20 h-20 bg-gradient-to-br from-blue-500 to-purple-600 rounded-lg shadow-2xl shadow-blue-500/50"
          style={{ transform: 'translateZ(40px)' }}></div>

        {/* Back face */}
        <div className="absolute w-20 h-20 bg-gradient-to-br from-purple-600 to-pink-600 rounded-lg shadow-2xl shadow-purple-500/50"
          style={{ transform: 'rotateY(180deg) translateZ(40px)' }}></div>

        {/* Top face */}
        <div className="absolute w-20 h-20 bg-gradient-to-br from-cyan-500 to-blue-600 rounded-lg shadow-2xl shadow-cyan-500/50"
          style={{ transform: 'rotateX(90deg) translateZ(40px)' }}></div>

        {/* Bottom face */}
        <div className="absolute w-20 h-20 bg-gradient-to-br from-pink-600 to-rose-600 rounded-lg shadow-2xl shadow-pink-500/50"
          style={{ transform: 'rotateX(-90deg) translateZ(40px)' }}></div>

        {/* Left face */}
        <div className="absolute w-20 h-20 bg-gradient-to-br from-indigo-600 to-blue-600 rounded-lg shadow-2xl shadow-indigo-500/50"
          style={{ transform: 'rotateY(-90deg) translateZ(40px)' }}></div>

        {/* Right face */}
        <div className="absolute w-20 h-20 bg-gradient-to-br from-violet-600 to-purple-600 rounded-lg shadow-2xl shadow-violet-500/50"
          style={{ transform: 'rotateY(90deg) translateZ(40px)' }}></div>
      </div>

      {/* Glow effect */}
      <div className="absolute inset-0 rounded-full bg-blue-500/10 blur-xl animate-pulse"></div>
    </div>,

    // Loader 2: 3D Orbital System
    <div className="relative w-32 h-32">
      {/* Central Sphere */}
      <div className="absolute inset-0 flex items-center justify-center">
        <div className="w-12 h-12 bg-gradient-to-r from-emerald-500 to-teal-400 rounded-full shadow-2xl shadow-emerald-500/50 animate-pulse"></div>
        <div className="absolute w-16 h-16 border-2 border-emerald-400/30 rounded-full animate-ping"></div>
      </div>

      {/* Orbiting Rings */}
      <div className="absolute inset-0 animate-[spin_12s_linear_infinite]">
        <div className="absolute top-0 left-1/2 -translate-x-1/2 w-4 h-4 bg-gradient-to-r from-cyan-500 to-blue-500 rounded-full shadow-lg shadow-cyan-500"></div>
        <div className="absolute bottom-0 left-1/2 -translate-x-1/2 w-4 h-4 bg-gradient-to-r from-purple-500 to-pink-500 rounded-full shadow-lg shadow-purple-500"></div>
        <div className="absolute left-0 top-1/2 -translate-y-1/2 w-4 h-4 bg-gradient-to-r from-orange-500 to-red-500 rounded-full shadow-lg shadow-orange-500"></div>
        <div className="absolute right-0 top-1/2 -translate-y-1/2 w-4 h-4 bg-gradient-to-r from-yellow-500 to-amber-500 rounded-full shadow-lg shadow-yellow-500"></div>
      </div>

      {/* Outer Orbit Ring */}
      <div className="absolute inset-0 border-2 border-dashed border-white/20 rounded-full animate-[spin_16s_linear_infinite_reverse]"></div>
    </div>,

    // Loader 3: 3D Hexagon Processor (Updated with proper CSS)
    <div className="relative w-32 h-32">
      {/* Hexagon Grid */}
      <div className="absolute inset-0 flex items-center justify-center">
        <div className="relative w-24 h-24">
          {/* Outer Hexagon */}
          <div className="absolute inset-0 bg-gradient-to-r from-blue-600/20 to-purple-600/20 animate-pulse"
            style={{ clipPath: 'polygon(25% 0%, 75% 0%, 100% 50%, 75% 100%, 25% 100%, 0% 50%)' }}></div>

          {/* Rotating Hexagon */}
          <div className="absolute inset-2 bg-gradient-to-r from-cyan-500/30 to-blue-500/30 animate-[spin_6s_linear_infinite]"
            style={{ clipPath: 'polygon(25% 0%, 75% 0%, 100% 50%, 75% 100%, 25% 100%, 0% 50%)' }}></div>

          {/* Inner Hexagon */}
          <div className="absolute inset-4 bg-gradient-to-r from-emerald-500/40 to-teal-400/40 animate-pulse"
            style={{ animationDuration: '3s', clipPath: 'polygon(25% 0%, 75% 0%, 100% 50%, 75% 100%, 25% 100%, 0% 50%)' }}></div>

          {/* Core */}
          <div className="absolute inset-8 bg-gradient-to-r from-white to-emerald-200 shadow-2xl shadow-emerald-500/50"
            style={{ clipPath: 'polygon(25% 0%, 75% 0%, 100% 50%, 75% 100%, 25% 100%, 0% 50%)' }}></div>
        </div>
      </div>

      {/* Floating Particles */}
      {[...Array(6)].map((_, i) => (
        <div
          key={i}
          className="absolute w-2 h-2 bg-gradient-to-r from-cyan-400 to-blue-400 rounded-full"
          style={{
            left: `${50 + 40 * Math.cos((i * 60 * Math.PI) / 180)}%`,
            top: `${50 + 40 * Math.sin((i * 60 * Math.PI) / 180)}%`,
            animation: `float 3s ease-in-out infinite`,
            animationDelay: `${i * 0.2}s`
          }}
        ></div>
      ))}
    </div>
  ];

  return (
    <div className="fixed inset-0 z-[9999] bg-gradient-to-br from-gray-900 via-slate-900 to-gray-950 text-white flex flex-col justify-center items-center transition-opacity duration-700 overflow-hidden">
      {/* Animated Background Elements */}
      <div className="absolute inset-0 overflow-hidden">
        <div className="absolute top-1/4 left-1/4 w-64 h-64 bg-blue-500/5 rounded-full blur-3xl animate-pulse"></div>
        <div className="absolute bottom-1/4 right-1/4 w-64 h-64 bg-purple-500/5 rounded-full blur-3xl animate-pulse"
          style={{ animationDelay: '0.7s' }}></div>
        <div className="absolute top-3/4 left-3/4 w-48 h-48 bg-emerald-500/5 rounded-full blur-3xl animate-pulse"
          style={{ animationDelay: '1s' }}></div>
      </div>

      {/* Current Loader */}
      <div className="relative z-10">
        {loaders[currentLoader]}
      </div>

      {/* Text with Pulse Animation */}
      <div className="mt-8 text-center">
        <h1 className="text-2xl font-bold bg-gradient-to-r from-cyan-400 via-blue-400 to-purple-400 bg-clip-text text-transparent animate-gradient">
          Launching <span className="text-emerald-400">MominHussain</span>
        </h1>
        <p className="mt-4 text-gray-300 text-lg max-w-md relative">
          <span className="relative inline-block">
            Crafting Digital Experiences
            <span className="absolute -bottom-1 left-0 w-full h-0.5 bg-gradient-to-r from-cyan-500 via-blue-500 to-purple-500 animate-pulse"></span>
          </span>
        </p>

        {/* Pulse Dots */}
        <div className="mt-6 flex justify-center space-x-3">
          {[0, 1, 2].map((dot) => (
            <div
              key={dot}
              className="w-3 h-3 rounded-full bg-gradient-to-r from-cyan-500 to-blue-500 animate-ping"
              style={{ animationDelay: `${dot * 0.3}s` }}
            ></div>
          ))}
        </div>
      </div>

      {/* Loading Progress Bar */}
      <div className="absolute bottom-10 w-80">
        <div className="flex justify-between items-center mb-2">
          <span className="text-sm text-gray-300">Initializing...</span>
          <span className="text-sm font-semibold text-emerald-400">{Math.min(Math.round(percentage), 100)}%</span>
        </div>
        <div className="h-2 bg-gray-800 rounded-full overflow-hidden">
          <div
            className="h-full bg-gradient-to-r from-cyan-500 via-blue-500 to-purple-500 transition-all duration-300 ease-out"
            style={{ width: `${Math.min(percentage, 100)}%` }}
          ></div>
        </div>
        <div className="mt-3 flex justify-between text-xs text-gray-400">
          <span>System Ready</span>
          <span className="text-emerald-400 animate-pulse">✨ Premium Experience</span>
        </div>
      </div>
    </div>
  );
};

export default PageLoader;